// import Img from "gatsby-image"
import tw from "twin.macro"
import styled from "@emotion/styled/macro"

// import { StyledImage } from "../../Styled/Image"
// import { StyledLink } from "../../Styled/Button"
// import { H2, P } from "../../Styled/Text"

import { H1 } from "../Styled/Text"
import { StyledContainer } from "../Styled/Container"

export const Banner = tw.div`relative bg-navy h-full`
export const Container = tw(StyledContainer)`py-8 md:py-16`
export const ImageContainer = styled.div`
  &,
  > * {
    ${tw`inset-0`}
    position: absolute !important;
  }

 > styledColumn {
  justify-content: flex-start;
 } 
`

export const Content = styled.div`
  ${tw`relative flex flex-col md:items-end justify-start text-white py-24 md:pt-28.25 px-4`}
  
    width: fit-content
  `



export const RichText = styled.p`
  ${tw`text-sm md:text-lg leading-7 md:leading-10 text-center md:text-left `}

    @media only screen and (min-width: 767px) {
      width: 42.5rem;
    }
`

export const Image = tw.img`absolute w-full top-1/2 transform -translate-y-1/2 min-h-full object-cover`
export const Gradient = tw.div`absolute inset-x-0 top-0 bottom-0 bg-gradient-to-b bg-gradient-to-r from-transparent to-navy-dark`
export const Link = tw.a`underline hover:text-teal transition-all duration-200 `
export const Section = tw.section`relative z-1 bg-white overflow-hidden h-full`
export const Title = tw(H1)`mb-4 md:mb-8 text-xl md:text-4xl text-center md:text-left`
export const TextContainer = tw.div`max-w-screen-xl mx-auto min-h-vh75 flex items-center justify-end`
